export default __webpack_public_path__ + "static/media/hero.d3b4e75a.jpg";